import { ControlledSelectInput2 } from 'Components';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { ChangeEvent, useContext } from 'react';

export const YearRange = () => {
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const isDesktop = useIsDesktop();

  const yearRange: string[] = [];
  for (
    let year = advancedSearch.dateMinMaxRange.min.getFullYear();
    year <= advancedSearch.dateMinMaxRange.max.getFullYear();
    year++
  )
    yearRange.push(year.toString());

  const range = advancedSearch.dateRange.start
    ? new Date(advancedSearch.dateRange.start).getFullYear().toString()
    : '';

  return (
    <ControlledSelectInput2
      size={'small'}
      disablePortal={isDesktop ? false : true}
      label={Dictionary[DICTIONARY.PaymentsDeductions].search.year}
      value={range}
      options={[...yearRange]}
      onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        dispatchAdvancedSearch({
          type: 'REQUEST_DATE_RANGE',
          payload: {
            value: {
              start: new Date(Number(e.target.value), 0, 1),
              end: new Date(Number(e.target.value), 11, 31),
              isYear: true,
            },
          },
        });
      }}
    />
  );
};
